import Facility from "./Facility";

class Facilities {
  constructor(private readonly _list: Facility[] = []) {
  }

  public toList() {
    return this._list;
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }
}

export default Facilities;
